import { cx } from "@light-technology/components";

type PlaybookDisclaimerProps = {
  className?: string;
};

export const PlaybookDisclaimer = ({ className }: PlaybookDisclaimerProps) => (
  <div
    className={cx(
      `flex flex-col gap-2xl text-xs text-tertiary italic`,
      className,
    )}
  >
    <p>
      The content in the Light Playbook is for informational purposes only and
      does not constitute legal, regulatory, financial, or compliance advice.
      While we aim to keep materials accurate and current, we make no warranties
      regarding the completeness or accuracy of any content herein.
    </p>
    <p>
      Content is subject to change without notice. © 2026 Light. All rights
      reserved.
    </p>
  </div>
);
